var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardsSchoolEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 512,
    viewBox: "0 0 516 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.684 289.684L290.043 363.4L355.052 351.05L504.933 201.171C512.019 194.085 516 184.475 516 174.454C516 164.433 512.019 154.823 504.933 147.737L470.283 113.087L293.684 289.684Z",
    fill: "#00A5C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.684 289.684L117.084 466.284L151.734 500.934C158.82 508.02 168.43 512 178.451 512C188.472 512 198.082 508.02 205.168 500.934L355.051 351.052L293.684 289.684Z",
    fill: "#BF4E57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M314.826 11.071L164.949 160.949L203.994 277.349L320.4 316.4L470.276 166.52C473.785 163.012 476.569 158.847 478.469 154.263C480.368 149.679 481.346 144.766 481.347 139.804C481.347 134.843 480.371 129.929 478.472 125.345C476.574 120.76 473.791 116.595 470.283 113.086L368.261 11.064C364.752 7.55573 360.587 4.77298 356.002 2.87465C351.418 0.97632 346.504 -0.000405551 341.542 0.000244465C336.58 0.000894481 331.667 0.978907 327.083 2.87844C322.499 4.77797 318.334 7.56181 314.826 11.071Z",
    fill: "#42C3E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.949 160.949L320.4 316.4L170.52 466.276C167.012 469.785 162.847 472.569 158.264 474.469C153.68 476.368 148.766 477.346 143.805 477.347C138.843 477.347 133.929 476.371 129.345 474.472C124.761 472.574 120.595 469.791 117.086 466.283L15.0642 364.261C11.5559 360.752 8.77319 356.587 6.87487 352.002C4.97656 347.418 3.99984 342.504 4.00049 337.543C4.00114 332.581 4.97914 327.668 6.87866 323.084C8.77818 318.5 11.562 314.335 15.0712 310.827L164.949 160.949Z",
    fill: "#DC5A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsSchoolEraser);
export default __webpack_public_path__ + "static/media/cards_school_eraser.b210bc683eb67e907d2c17ac3086c48e.svg";
export { ForwardRef as ReactComponent };